// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"BanModal-bodyText-70b846c6aeb32f7b520e5733a910a0d7","textArea":"BanModal-textArea-5f39b0e3368b058d0afb6035276e65dd"};